/**
 * API Configuration
 * Derived from Environment Variables
 */

/**
 * 解析 mock transport 开关。
 *
 * 生产打包时如果 env 文件编码异常或变量缺失，不能默认进入 mock；
 * mock 只允许本地调试通过 `VITE_USE_MOCK=true` 显式开启。
 *
 * @param value 环境变量中的原始 mock 开关值。
 * @returns 仅当值为 `true` 时返回 true。
 */
export function resolveUseMockFlag(value: unknown): boolean {
  return typeof value === 'string' && value.trim().toLowerCase() === 'true'
}

/**
 * 判断外部登录地址是否由环境变量显式提供。
 *
 * 设计说明：
 * 1. `externalAuthUrl` 仍保留本地默认值，方便旧开发链路不被破坏；
 * 2. 运行中会话失效需要知道“是否真的配置了登录入口”，避免生产环境错误跳到 localhost。
 *
 * @param value 环境变量中的原始登录地址。
 * @returns 仅当环境变量是非空字符串时返回 true。
 */
export function resolveExternalAuthUrlConfigured(value: unknown): boolean {
  return typeof value === 'string' && value.trim().length > 0
}

export const apiConfig = {
  // EI2: Backend Base URL
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,

  // Auth Integration
  externalAuthUrl: import.meta.env.VITE_EXTERNAL_AUTH_URL || 'http://localhost:9000/auth',
  externalAuthUrlConfigured: resolveExternalAuthUrlConfigured(import.meta.env.VITE_EXTERNAL_AUTH_URL),
  externalProfileUrl: import.meta.env.VITE_EXTERNAL_PROFILE_URL || 'http://localhost:9000/profile',
  externalHomeUrl: import.meta.env.VITE_EXTERNAL_HOME_URL || 'http://localhost:9000/home',

  // Mock Toggle: 只有显式配置 true 才启用，避免生产 env 缺失时误进入 mock 登录。
  useMock: resolveUseMockFlag(import.meta.env.VITE_USE_MOCK),

  // Development-only auto login (仅在 import.meta.env.DEV === true 时生效)
  devAuth: {
    autoLoginEnabled: import.meta.env.VITE_DEV_AUTO_LOGIN_ENABLED === 'true',
    autoLoginUsername: import.meta.env.VITE_DEV_AUTO_LOGIN_USERNAME || '',
    autoLoginPassword: import.meta.env.VITE_DEV_AUTO_LOGIN_PASSWORD || '',
    autoLoginTenantId: import.meta.env.VITE_DEV_AUTO_LOGIN_TENANT_ID || '',
    autoOpenProjectId: import.meta.env.VITE_DEV_AUTO_OPEN_PROJECT_ID || '',
    autoOpenRepositoryId: import.meta.env.VITE_DEV_AUTO_OPEN_REPOSITORY_ID || '',
    autoOpenBranchId: import.meta.env.VITE_DEV_AUTO_OPEN_BRANCH_ID || '',
  },
};
